import { Context } from "../../index";
import { Button } from "react-bootstrap";
import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";
import { FaDollarSign } from "react-icons/fa";

const PriceFiltrG = observer(() => {
    const { book } = useContext(Context);
    const [hoveredItemId, setHoveredItemId] = useState(null);

    // ✅ Правильный тоггл выбора цены (повторный клик — снять)
    const handlePriceClick = (price) => {
        const currentId = book.selectedPrice?.id ?? null;
        const next = currentId === price.id ? "" : price; // ← '' снимает выбор
        book.setSelectedPrice(next);
    };

    return (
        <div>
            <div className="d-flex flex-wrap justify-content-start">
                {book.prices.slice(0, 8).map((g) => {
                    const isActive = book.selectedPrice?.id === g.id;
                    return (
                        <Button
                            key={g.id}
                            variant={hoveredItemId === g.id || isActive ? "success" : "outline-success"}
                            className="mx-1 d-flex btn-sm mb-2 align-items-center justify-content-start"
                            style={{
                                transition: "transform 0.2s",
                                transform: hoveredItemId === g.id ? "scale(1.1)" : "scale(1)",
                            }}
                            onMouseEnter={() => setHoveredItemId(g.id)}
                            onMouseLeave={() => setHoveredItemId(null)}
                            onClick={() => handlePriceClick(g)}
                            active={isActive}           // ✅ визуально активная
                            aria-pressed={isActive}     // ♿️ доступность
                        >
                            {(g.price_for_show_in_library !== "More" &&
                                g.price_for_show_in_library !== "Free") && (
                                <FaDollarSign style={{ marginLeft: "-3px" }} />
                            )}
                            {g.price_for_show_in_library}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
});

export default PriceFiltrG;
